<template>
  <v-main class="app-gecros-access d-flex align-center justify-center">
    <v-sheet class="app-gecros-access__panel pa-6 text-center" elevation="0">
      <v-progress-circular
        v-if="!error"
        indeterminate
        color="primary"
        size="40"
        width="4"
        class="mb-4"
      />
      <v-icon
        v-else
        icon="mdi-alert-circle-outline"
        color="warning"
        size="42"
        class="mb-4"
      />
      <h1 class="text-subtitle-1 font-weight-semibold mb-2">
        {{ title }}
      </h1>
      <p class="text-body-2 text-medium-emphasis mb-0">
        {{ message }}
      </p>
    </v-sheet>
  </v-main>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AppGecrosAccess',
  data() {
    return {
      error: false,
    }
  },
  computed: {
    title() {
      return this.error ? 'No se pudo ingresar' : 'Redirigiendo al portal'
    },
    message() {
      return this.error
        ? 'El enlace de acceso no contiene un token valido.'
        : 'Aguarde un momento.'
    },
  },
  mounted() {
    this.loginAndRedirect()
  },
  methods: {
    ...mapActions({
      setAlert: 'alerts/setAlert',
    }),
    async loginAndRedirect() {
      const token = String(this.$route.params.tokenBenef ?? '').trim()

      if (!token) {
        this.error = true
        this.setAlert({
          type: 'warning',
          message: 'El enlace de acceso no contiene un token valido.',
        })
        return
      }

      localStorage.removeItem('token')
      this.$store.commit('guestSession/resetGuestSession')
      localStorage.setItem('token', token)

      await this.$router.replace({ path: '/' })
    },
  },
}
</script>

<style scoped>
.app-gecros-access {
  min-height: 100vh;
  min-height: 100dvh;
  background: rgb(var(--v-theme-background));
}

.app-gecros-access__panel {
  width: min(100% - 32px, 360px);
  border: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
  border-radius: 8px;
}
</style>
